import React, { useEffect, useState, useRef, useCallback } from "react";
import Input from "../../../components/controls/input/customInput/CustomInput";
import Button from "../../../components/controls/button/Button";
import InputUnderline from "../../../components/controls/input/InputUnderline";
import { CalendarIcon, AddIconSvg } from "../../../modules/default-svg";
import service from "../../../store/services/user.service";
import clientsService from "../../../store/services/clients.service";
import portfolioService from "../../../store/services/portfolio.service";
import programService from "../../../store/services/programs.service";
import Searchable from "../../../components/controls/select/CustomSelect";
import projectService from "../../../store/services/projects.service";
import {
  AvatarGroup,
  AvatarGroupItem,
  AvatarGroupPopover,
  partitionAvatarGroupItems,
} from "@fluentui/react-components";
import CustomSelect from "../../../components/controls/select/CustomSelect";
import { apiCall } from "../../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../../store/services/URL";
import {
  calculatePageSize,
  getLabelByType,
  projectStatus,
  projectTypes,
  UserSearchRefType,
} from "../../../helpers/utils";
import DropDown from "../../../components/controls/dropdown/DropdownFluent";
import { ColumnConfigProvider } from "../../../components/controls/tables/ColumnConfigProvider";
import ContactsSelect from "../../../components/contactsSelect/ContactsSelect";
import {
  getAccountCurrency,
  displayDecimalFormatted,
  isDateGreaterThan,
} from "../../../utils/systemSettings";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../store/actions";
import DeleteRequest from "../../../components/DeleteRequest/DeleteRequest";
import Table from "../../../components/controls/tables/Table";
import RichTextEditor from "../../../components/richTextEditor/RichTextEditor";
import EntityFileUpload from "../../../components/controls/fileUpload/EntityFileUpload";
import { getPortFolioBudgetSummary, getPortFolioProgressSummary } from "../../../store/actions/portfolio.actions";
import { getProgramBudgetSummary, getProgramProgressSummary } from "../../../store/actions/programs.actions";
import UserSelect from "../../../components/userSelect/UserSelect";

const Projects = (props) => {
  const {
    clientID,
    defaultClient,
    defaultPortfolio,
    defaultProgram,
    programID,
    portfolioID,
    allProjects,
    pageLoading,
    loading,
    pagination,
    getProjectsRequest,
    createProjectRequest,
    updateProjectRequest,
    error,
    overviewType,
  } = props;
  const permissions = localStorage.getItem("permissions");
  const settings = JSON.parse(localStorage.getItem("settings"));
  const prevClientId = useRef(null);
  const manualUpdate = useRef({
    client: false,
    portfolio: false,
    program: false,
  });
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [setting] = useState(settings);
  const [data, setData] = useState([]);
  const [perPageItems] = useState(calculatePageSize());
  const [pageNum, setPageNum] = useState(1);
  const [isCreate, setIsCreate] = useState(false);
  const [isHeader, setIsHeader] = useState(true);
  const [name, setName] = useState("");
  const [type, setType] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [revisedEndDate, setRevisedEndDate] = useState("");
  const [projectId, setProjectId] = useState("");
  const [newExecutive, setNewExecutive] = useState("");
  const [executive, setExecutive] = useState(null);
  const [executiveId, setExecutiveId] = useState({});
  const [newSponsor, setNewSponsor] = useState("");
  const [sponsor, setSponsor] = useState(null);
  const [sponsorId, setSponsorId] = useState("");
  const [newStakeholders, setNewStakeholders] = useState("");
  const [stakeholders, setStakeholders] = useState([]);
  const [stakeholdersIds, setStakeholdersIds] = useState("");
  const [budget, setBudget] = useState("");
  const [status, setStatus] = useState(0);
  const [refId, setRefId] = useState("");
  const [progress, setProgress] = useState(0);

  const [clients, setClients] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [portfolios, setPortfolios] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [industryOptions, setIndustryOptions] = useState([]);

  const [description, setDescription] = useState("");
  const [selectedRow, setSelectedRow] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isCreateNewRow, setIsCreateNewRow] = useState(false);
  const [deleteId, setDeletedId] = useState(null);
  const [attachments, setAttachments] = useState([]);

  const [manager, setManager] = useState(null);
  const [lead, setLead] = useState(null);
  const [client, setClient] = useState("");
  const [program, setProgram] = useState("");
  const [portfolio, setPortfolio] = useState("");
  const [flag, setFlag] = useState(false);
  const [parentType, setParentType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({
    name: "",
    type: "",
    client: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
  });

  const [deleteRequestModal, setDeleteRequestModal] = useState(false);
  const [deleteRequestData, setDeleteRequestData] = useState({});
  const [deleteModal, setDeleteModal] = useState(null);

  const [tableSearch, setTableSearch] = useState(null);
  const dispatch = useDispatch();
  const resetFormStates = useCallback(() => {
    setName("");
    setType(null);
    setStartDate("");
    setEndDate("");
    setRevisedEndDate("");
    setExecutive(null);
    setExecutiveId("");
    setSponsor(null);
    setSponsorId("");
    setBudget(0);
    setStatus(0);
    setRefId("");
    setStakeholders([]);
    setStakeholdersIds("");
    setDescription("");
    setClients([]);
    setManager(null);
    setLead(null);
    setPrograms([]);
    setPortfolios([]);
    setIndustries([]);
    setFormErrors({
      name: "",
      client: "",
      startDate: "",
      endDate: "",
      revisedEndDate: "",
    });
  }, []);

  useEffect(() => {
    if (error !== "") {
      error &&
        Object.keys(error).forEach((key) => {
          if (key === "Name") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              name: error[key][0],
            }));
          }
          if (key === "ClientId") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              client: error[key][0],
            }));
          }
        });
    } else {
      setFormErrors({});
    }
  }, [error]);

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    service
      .searchClientDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolios([]);
      return;
    }
    const payload = { id: client?.value, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (client)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolios(transformedArray);
      })
      .catch(() => {
        setPortfolios([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setPrograms([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Project";

    if (client) {
      queryParam = `?clientId=${client?.value}&searchTerm=${payload.searchText}`;
    }

    if (portfolio) {
      queryParam = `?portfolioId=${portfolio.value}&searchTerm=${payload.searchText}`;
    }

    if (client && portfolio) {
      queryParam = `?clientId=${client.value}&portfolioId=${portfolio.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPrograms(transformedArray);
      })
      .catch(() => {
        setPrograms([]);
      });
  };

  const fetchProjectData = async () => {
    setIsLoading(true);
    projectService
      .getProjectDetailsRequest({ id: selectedRow.id })
      .then((projectData) => {
        setProjectId(projectData.id);
        setName(projectData.name);
        setType(projectData.type);
        setStartDate(projectData.startDate);
        setEndDate(projectData.endDate);
        setRevisedEndDate(projectData.revisedEndDate);
        setExecutive(projectData.executive);
        setExecutiveId(projectData.executive?.id);
        setSponsor(projectData.sponsor);
        setSponsorId(projectData.sponsor?.id);
        setBudget(projectData.budget);
        setStatus(projectData.status);
        setRefId(projectData.refId);
        setStakeholders(projectData.stakeholders);
        setStakeholdersIds(
          projectData.stakeholders?.length > 0
            ? projectData.stakeholders.map((contact) => contact.id).join(",")
            : ""
        );
        setDescription(projectData.description);
        setProgress(projectData.progress);
        // setUsersId(projectData.users);
        if (projectData.program) {
          const programArray = {
            value: projectData.program.id,
            label: projectData.program.name,
          };
          setProgram(programArray);
        } else {
          setProgram("");
        }
        if (projectData.portfolio) {
          const portfolioArray = {
            value: projectData.portfolio.id,
            label: projectData.portfolio.name,
          };
          setPortfolio(portfolioArray);
        } else {
          setPortfolio("");
        }
        const clientArray = {
          value: projectData.client.id,
          label: projectData.client.name,
        };
        setClient(clientArray);
        setManager(projectData.owner);
        setLead(projectData.lead);
        setAttachments(projectData.attachments || []);
        setIndustries(projectData.industries || []);
        setIsLoading(false);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  // Fetches at most once per selected client - CustomSelect's onFocus can fire
  // more than once per interaction (it programmatically calls openMenu()), and
  // react-select's onInputChange also fires on blur/menu-close, so this cache
  // is the actual guard against repeat calls, not the actionMeta check below.
  const fetchedIndustriesClientIdRef = useRef(null);
  const fetchClientIndustries = (clientId) => {
    if (!clientId) {
      fetchedIndustriesClientIdRef.current = null;
      setIndustryOptions([]);
      return;
    }
    if (fetchedIndustriesClientIdRef.current === clientId) {
      return;
    }
    fetchedIndustriesClientIdRef.current = clientId;
    clientsService
      .getClientIndustriesRequest(clientId)
      .then((res) => {
        const transformed = (res || []).map((obj) => ({ label: obj.name, value: obj.id }));
        setIndustryOptions(transformed);
      })
      .catch(() => {
        fetchedIndustriesClientIdRef.current = null;
        setIndustryOptions([]);
      });
  };

  const handleIndustrySearch = (value, actionMeta) => {
    if (value !== null && actionMeta && actionMeta.action !== "input-change") {
      return;
    }
    fetchClientIndustries(client?.value);
  };

  const handleIndustriesChange = (ids) => {
    const pool = [...industries, ...industryOptions.map((o) => ({ id: o.value, name: o.label }))];
    const selected = ids.map((id) => pool.find((item) => item.id === id)).filter(Boolean);
    setIndustries(selected);
  };

  useEffect(() => {
    if (defaultClient) {
      setClient({ value: defaultClient.id, label: defaultClient.name });
      prevClientId.current = defaultClient.id;
    }
  }, [defaultClient]);

  useEffect(() => {
    if (defaultPortfolio) {
      setPortfolio({
        value: defaultPortfolio.id,
        label: defaultPortfolio.name,
      });
    }
  }, [defaultPortfolio]);

  useEffect(() => {
    if (defaultProgram) {
      setProgram({ value: defaultProgram.id, label: defaultProgram.name });
    }
  }, [defaultProgram]);

  useEffect(() => {
    if (Object.keys(selectedRow).length > 0) {
      isEdit && fetchProjectData();
      // getUsersRequest({ page: 1, Size: 10 });
    } else {
      resetFormStates();
      defaultProgram
        ? setProgram({ value: defaultProgram.id, label: defaultProgram.name })
        : setProgram("");
      defaultPortfolio
        ? setPortfolio({
          value: defaultPortfolio.id,
          label: defaultPortfolio.name,
        })
        : setPortfolio("");
      defaultClient
        ? setClient({ value: defaultClient.id, label: defaultClient.name })
        : setClient("");
    }
  }, [selectedRow, isEdit, resetFormStates]);

  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch = false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    payload.parent = parentType;

    if (clientID) {
      payload.id = clientID;
      payload.parent = "Client";
    }

    if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }

    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }
    getProjectsRequest(payload);
  };

  const handleAddRow = useCallback(() => {
    setIsCreateNewRow(true);
    const payload = {
      page: pagination.TotalPages ?? 1,
      size: perPageItems > 10 ? perPageItems - 5 : perPageItems - 3,
    };
    payload.parent = parentType;

    if (clientID) {
      payload.id = clientID;
      payload.parent = "Client";
    }

    if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }

    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }
    getProjectsRequest(payload);
  }, []);

  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems, flag]);

  const handleSearchTrigger = (searchTerm) => {
    if ((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if (!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)) {
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
    }

    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);
  };

  const handleCancelAddRow = () => {
    setIsCreateNewRow(false);
    fetchData();
  };

  // While creating a new project there's no Project id yet to search contacts against,
  // so scope the Executive/Sponsor/Stakeholders pickers to whichever of Program/Portfolio/Client
  // is already selected (most specific first) - the contacts search there already includes
  // shared contacts from that node's own ancestors. Once the project exists (isEdit), search
  // against the project itself as before (it already resolves shared ancestor contacts too).
  const contactSearchScope = isEdit
    ? { parentType: "Projects", parentId: selectedRow.id }
    : program?.value || programID
    ? { parentType: "Programs", parentId: program?.value || programID }
    : portfolio?.value || portfolioID
    ? { parentType: "Portfolios", parentId: portfolio?.value || portfolioID }
    : { parentType: "Clients", parentId: client?.value || clientID };

  const formBody = () => {
    return (
      <>
        <div className="d-flex align-items-end justify-content-between">
          <div className={"col-8"}>
            <InputUnderline
              placeholder="Add project name"
              value={name}
              handleChange={(value) => handleInputChange(value, "name")}
              error={formErrors.name}
              isRequired
              loading={isLoading}
            />
          </div>
          {!isEdit && (
            <div className="col-3">
              <label class="Input_label">Type</label>
              <DropDown
                label="Type"
                showLabel={false}
                options={projectTypes}
                defaultVal={getLabelByType("projectType", type)}
                onChange={(value) => handleInputChange(value, "type")}
                loading={isLoading}
              />
              {formErrors.type && <p className="InputUnderline_errorMessage">{formErrors.type}</p>}
            </div>
          )
          }

          {isEdit && (
            <>
              <div className="col-2 ml-2">
                <label class="Input_label">Type</label>
                <p
                  style={{ border: "1px solid #342C82", backgroundColor: type == 0 ? "#EDECF8" : "#DBEAFE", color: type == 0 ? "#342C82" : "#1E40AF" }}
                  className="text-xs font-semibold text-center py-[4px] rounded-md"
                >
                  {`${getLabelByType("projectType", type)}`}
                </p>
              </div>
              <div className="col-1 ml-1">
                <label class="Input_label">Progress</label>
                <p
                  style={{ border: "1px solid #342C82" }}
                  className="text-xs text-[#1F1F1F] font-semibold bg-[#EDECF8] text-center py-[4px] rounded-md"
                >
                  {`${progress} %`}
                </p>
              </div>
            </>

          )}
        </div>

        <div className="row gx-3 mb-3">
          {overviewType !== "Client" &&
            overviewType !== "Portfolio" &&
            overviewType !== "Program" && (
              <div className="col mt-3 w-100">
                <Searchable
                  label="Client"
                  SelectText="client"
                  searchText={searchClientHandler}
                  options={clients}
                  defaultVal={client}
                  onChange={(value) => handleInputChange(value, "client")}
                  errorMessage={formErrors.client}
                  isRequired
                  loading={isLoading}
                />
              </div>
            )}
          {overviewType !== "Portfolio" && overviewType !== "Program" && (
            <div className="col mt-3 w-100">
              <Searchable
                label="Portfolio"
                SelectText="portfolio"
                searchText={searchPortfolioHandler}
                options={portfolios}
                defaultVal={portfolio}
                onChange={(e) => {
                  setPortfolio(e);
                  setProgram("");
                }}
                loading={isLoading}
              />
            </div>
          )}
          {overviewType !== "Program" && (
            <div className="col mt-3 w-100">
              <Searchable
                label="Program"
                SelectText="program"
                searchText={searchProgramHandler}
                options={programs}
                defaultVal={program}
                onChange={setProgram}
                loading={isLoading}
              />
            </div>
          )}
          <div className="col mt-3 w-100">
            <Searchable
              label="Industry"
              SelectText="industry"
              multiselect={true}
              creatable={false}
              searchText={handleIndustrySearch}
              options={industryOptions}
              defaultVal={industries.map((i) => ({ label: i.name, value: i.id }))}
              onChange={handleIndustriesChange}
              isDisabled={!client?.value}
              loading={isLoading}
            />
          </div>
        </div>
        <div className="ModalAvatarGroup">
          <div className="row align-items-start gx-3">
            {
              isEdit && (
                <>
                  <div className="col-3">
                    <UserSelect
                      refType={UserSearchRefType.Project}
                      refId={projectId}
                      label="Project Manager"
                      buttonLabel={"Select Manager"}
                      value={manager}
                      onChange={setManager}
                      loading={isLoading}
                      disabled={!projectId && !client}
                    />
                  </div>
                  <div className="col-3">
                    <UserSelect
                      refType={UserSearchRefType.Project}
                      refId={projectId}
                      label="Technical Lead"
                      buttonLabel={"Select Lead"}
                      value={lead}
                      onChange={setLead}
                      loading={isLoading}
                      disabled={!projectId && !client}
                    />
                  </div>
                </>
              )
            }

            {!isLoading && (
              <>
                <div className="col-3">
                  <label class="Input_label">Executive</label>
                  <ContactsSelect
                    parentType={contactSearchScope.parentType}
                    parentId={contactSearchScope.parentId}
                    isMultiSelect={false}
                    isNewParent={!isEdit}
                    forNewChild={!isEdit}
                    confirmHandler={setExecutiveId}
                    submitNewContactHandler={setNewExecutive}
                    existingSelectedContacts={
                      executive ? [...[], executive] : []
                    }
                  />
                </div>
                <div className="col-3">
                  <label class="Input_label">Sponsor</label>
                  <ContactsSelect
                    parentType={contactSearchScope.parentType}
                    parentId={contactSearchScope.parentId}
                    isMultiSelect={false}
                    isNewParent={!isEdit}
                    forNewChild={!isEdit}
                    confirmHandler={setSponsorId}
                    submitNewContactHandler={setNewSponsor}
                    existingSelectedContacts={sponsor ? [...[], sponsor] : []}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter reference ID"
              value={refId}
              type="text"
              handleChange={setRefId}
              label="Reference ID"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <label class="Input_label">Status</label>
            <DropDown
              label="Status"
              showLabel={false}
              options={projectStatus}
              defaultVal={getLabelByType("project", status)}
              onChange={setStatus}
              loading={isLoading}
            />
          </div>

          {isEdit && (
            <div className="col-4">
              <label class="Input_label">Budget</label>
              <p
                style={{ border: "1px solid #342C82" }}
                className=" text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md"
              >
                {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  budget
                )}`}
              </p>
            </div>
          )}
        </div>
        <div className="row align-items-center gx-3">
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={startDate}
              maxDate={revisedEndDate ? revisedEndDate : endDate}
              type="date"
              handleChange={setStartDate}
              label="Start Date"
              errorMessage={formErrors.startDate}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={endDate}
              minDate={startDate}
              type="date"
              handleChange={setEndDate}
              label="End Date"
              errorMessage={formErrors.endDate}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={revisedEndDate}
              minDate={startDate}
              type="date"
              handleChange={setRevisedEndDate}
              label="Revised End Date"
              errorMessage={formErrors.revisedEndDate}
              loading={isLoading}
            />
          </div>
        </div>
        {!isLoading && (
          <div className="ModalAvatarGroup">
            <div className="row align-items-end gx-3">
              <div className="col-12">
                <label class="Input_label">Stakeholders</label>
                <ContactsSelect
                  parentType={contactSearchScope.parentType}
                  parentId={contactSearchScope.parentId}
                  isNewParent={!isEdit}
                  forNewChild={!isEdit}
                  confirmHandler={setStakeholdersIds}
                  submitNewContactHandler={(newContact) => {
                    setNewStakeholders((prev) => [...prev, newContact]);
                  }}
                  existingSelectedContacts={stakeholders}
                />
              </div>
            </div>
          </div>
        )}
        <div className="row mb-3">
          <div className="col-12">
            <RichTextEditor
              label="Description"
              content={description}
              onChange={setDescription}
              loading={isLoading}
            />
          </div>
        </div>

        <EntityFileUpload
          entityId={selectedRow.id}
          entityType="Project"
          attachments={attachments}
          onAttachmentsChange={() => {
            // Refresh project data to get updated attachments
            if (selectedRow.id) {
              projectService
                .getProjectDetailsRequest({ id: selectedRow.id })
                .then((projectData) => {
                  setAttachments(projectData.attachments);
                })
                .catch((error) => {
                  console.error("Error fetching project data:", error);
                });
            }
          }}
          disabled={isLoading || !selectedRow.id}
        />
      </>
    );
  };

  const handleInputChange = (value, name) => {
    if (name === "name") {
      setName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
    if (name === "type") {
      setType(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
    if (name === "client") {
      setClient(value);
      setPortfolio("");
      setProgram("");
      setManager(null);
      setLead(null);
      setIndustries([]);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  const handleDelete = (selectedRow) => {
    // const id = JSON.parse(localStorage.getItem("selectedRow")).id;
    const id = selectedRow.id;
    setIsModalLoading(true);
    projectService
      .deleteProjectRequest({ id })
      .then((response) => {
        setDeleteModal(false);
        if (response && !response.IsDeletionAllowed) {
          setDeleteRequestData(response);
          setDeleteRequestModal(true);
        } else {
          if (portfolioID) {
            dispatch(getPortFolioProgressSummary({ id: portfolioID }));
            dispatch(getPortFolioBudgetSummary({ id: portfolioID }));
          }
          else if (programID) {
            dispatch(getProgramProgressSummary({ id: programID }));
            dispatch(getProgramBudgetSummary({ id: programID }));
          }
          setDeletedId(id);
          fetchData();
        }
      })
      .catch((err) => {
        dispatch(
          generalActions.showToast({
            title: "Something went wrong. Please try again later.",
            type: "error",
          })
        );
      })
      .finally(() => {
        setSelectedRow({});
        setDeleteModal(false);
        setIsModalLoading(false);
      });
  };

  const handleDeleteRequested = () => {
    fetchData();
  };
  const handleSave = () => {
    const errors = {};
    if (!name) errors["name"] = `Required field`;
    if (!isEdit && type === null) errors["type"] = `Required field`;
    if (parentType !== "Client" && !client)
      errors["client"] = `Required field`;
    if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
      errors[
        "endDate"
      ] = `End date must be equal to or greater than start date.`;
    }
    if (
      startDate &&
      revisedEndDate &&
      isDateGreaterThan(startDate, revisedEndDate)
    ) {
      errors[
        "revisedEndDate"
      ] = `Revised end date must be equal to or greater than start date.`;
    }
    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }

    const payload = {
      Name: name,
      StartDate: startDate || null,
      EndDate: endDate || null,
      RevisedEndDate: revisedEndDate || null,
      ProgramId: program?.value || programID,
      ExecutiveId: executiveId,
      SponsorId: sponsorId,
      Status: status,
      RefId: refId,
      ClientId: client?.value,
      PortfolioId: portfolio?.value,
      Stakeholders: stakeholdersIds,
      Description: description,
      OwnerId: manager?.id,
      leadId: lead?.id,
      IndustryIds: industries.map((i) => i.id),
    };
    if (!isEdit) {
      payload.Type = type;
      payload.newExecutive = newExecutive ? JSON.stringify(newExecutive) : "";
      payload.newSponsor = newSponsor ? JSON.stringify(newSponsor) : "";
      payload.newStakeholders = newStakeholders
        ? JSON.stringify(newStakeholders)
        : "";
    }

    let data = {};
    if (Object.keys(selectedRow).length > 0) {
      data = { id: projectId, payload };
      data.parent = parentType;

      if (clientID) {
        data.parentId = clientID;
        data.parent = "Client";
      }
      if (portfolioID) {
        data.parentId = portfolioID;
        data.parent = "Portfolio";
      }
      // if (parentType === "Portfolio") {
      //   data.payload.PortfolioId = portfolioID;
      // }
      if (programID) {
        data.parentId = programID;
        data.parent = "Program";
      }
      updateProjectRequest(data);
    } else {
      data = { payload };
      if (clientID) {
        data.parentId = clientID;
        data.parent = "Client";
      }
      if (portfolioID) {
        data.parentId = portfolioID;
        data.parent = "Portfolio";
      }
      // if (parentType === "Portfolio") {
      //   data.payload.PortfolioId = portfolio && portfolio.value;
      // }
      if (programID) {
        data.parentId = programID;
        data.parent = "Program";
      }
      createProjectRequest(data);
    }
    setFlag(!flag);
  };

  const handleCreate = () => {
    setIsCreate(true);
  };

  const handleCancel = () => {
    setFormErrors({});
    setIsEdit(false);
  };

  useEffect(() => {
    if (clientID) {
      setParentType("Client");
      setIsHeader(false);
    }
    if (portfolioID) {
      setParentType("Portfolio");
      setIsHeader(false);
    }
    if (programID) {
      setParentType("Program");
      setProgram({ value: programID });
      setIsHeader(false);
    }
    setData([]);
    setPageNum(1);
    setDeletedId(null);
  }, [clientID, portfolioID, programID]);

  useEffect(() => {
    if (allProjects && allProjects.length > 0) {
      if (isCreateNewRow) {
        setData(
          allProjects.sort((a, b) => {
            return b.isFlagged - a.isFlagged;
          })
        );
        setIsCreateNewRow(false);
      } else {
        if (pageNum === 1) {
          setData(
            allProjects
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => {
                return b.isFlagged - a.isFlagged;
              })
          );
        } else {
          setData((prevData) => {
            const newMap = new Map(allProjects.map((item) => [item.id, item]));
            const updatedPrevData = prevData.map((item) =>
              newMap.has(item.id) ? newMap.get(item.id) : item
            );
            const prevDataIds = new Set(prevData.map((item) => item.id));
            const newItems = allProjects.filter(
              (shift) => !prevDataIds.has(shift.id)
            );
            return [...updatedPrevData, ...newItems]
              .filter((item) => item.id !== deleteId)
              .sort((a, b) => b.isFlagged - a.isFlagged);
          });
        }
      }
    } else if (allProjects && allProjects.length === 0 && pageNum === 1) {
      setData([]);
    }
  }, [allProjects]);

  useEffect(() => {
    if (program && !manualUpdate.current.portfolio) {
      if (!client && !portfolio) {
        programService
          .fetchProgramDataRequest({ id: program.value })
          .then((data) => {
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            data.client
              ? setClient({ label: data.client.name, value: data.client.id })
              : setClient("");
            data.portfolio
              ? setPortfolio({
                label: data.portfolio.name,
                value: data.portfolio.id,
              })
              : setPortfolio("");
          })
          .catch((error) =>
            console.error("Error fetching program data:", error)
          );
      }
    }
  }, [program]);

  useEffect(() => {
    if (!portfolio) {
      setProgram("");
    }
    if (portfolio && !manualUpdate.current.client) {
      if (!client) {
        portfolioService
          .getPortfolioDetails({ id: portfolio.value })
          ?.then((portfolioData) => {
            manualUpdate.current.client = true;
            portfolioData.client
              ? setClient({
                label: portfolioData.client.name,
                value: portfolioData.client.id,
              })
              : setClient("");
            setProgram("");
          })
          ?.catch((error) =>
            console.error("Error fetching portfolio data:", error)
          );
      } else {
        if (!isEdit) {
          setProgram("");
        }
      }
    }
  }, [portfolio]);

  useEffect(() => {
    if (!client) {
      setPortfolio("");
      setProgram("");
    }
    // if (client) {
    //   prevClientId.current = client.value;
    // }
    if (client && prevClientId.current === null) {
      prevClientId.current = client.value;
    }

    if (client && prevClientId.current !== client.value) {
      setPortfolio("");
      setProgram("");
      prevClientId.current = client.value;
    }
    manualUpdate.current.client = false;
    manualUpdate.current.portfolio = false;
    manualUpdate.current.program = false;
  }, [client]);

  return (
    <>
      <ColumnConfigProvider
        tableName={parentType ? `${parentType}-Project` : "Project"}
      >
        <div className="listingScreen position-relative">
          {isHeader && (
            <div className="db_Subheader d-flex justify-content-between align-items-center mb-4">
              <h4>Projects</h4>
              {permissions?.includes("Project.Create") && (
                <Button
                  btnClass="d_btn d_btn_primary"
                  icon={<AddIconSvg />}
                  label="Add Project"
                  clickHandler={handleCreate}
                />
              )}
            </div>
          )}

          <Table
            type="Project"
            isHeader={isHeader}
            parentType={parentType}
            rows={data || []}
            body={formBody()}
            saveBtnLabel="Save"
            cancelBtnLabel="Cancel"
            setPageNum={setPageNum}
            perPageItems={perPageItems}
            setIsCreate={setIsCreate}
            handleSave={() => handleSave()}
            handleDelete={(selectedRow) => handleDelete(selectedRow)}
            handleCancel={() => handleCancel()}
            setIsEdit={setIsEdit}
            loading={pageLoading}
            modalLoading={isModalLoading || loading}
            isCreate={isCreate}
            forceShowDeleteModal={deleteModal}
            pagination={pagination}
            setSelectedRow={setSelectedRow}
            clientId={clientID}
            portfolioId={portfolioID}
            programID={programID}
            projectId={projectId}
            handleAddRow={handleAddRow}
            handleCancelAddRow={handleCancelAddRow}
            setData={setData}
            triggerSearch={handleSearchTrigger}
          />
        </div>
        {deleteRequestModal && (
          <DeleteRequest
            data={deleteRequestData}
            handleCancel={setDeleteRequestModal}
            handleRefresh={() => handleDeleteRequested()}
          />
        )}
      </ColumnConfigProvider>
    </>
  );
};
export default Projects;
